// extracted by mini-css-extract-plugin
export default {"itemList":"BulkAddInput_itemList__mgNkj","listWrapper":"BulkAddInput_listWrapper__TFbbK"};